var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkSession(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99985 11H2.04785C2.54985 5.947 6.81285 2 11.9979 2C17.5209 2 21.9979 6.477 21.9979 12C21.9979 17.523 17.5209 22 11.9979 22C6.81285 22 2.54985 18.053 2.04785 13H9.99785V16L14.9979 12L9.99785 8L9.99985 11Z",
    fill: "#4C4C4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkSession);
export default __webpack_public_path__ + "static/media/dark-session.9f5df0a3c8342245920f3b9f279637e3.svg";
export { ForwardRef as ReactComponent };